
export const nl = {
  auth: {
    login: "Inloggen",
    startFreeTrial: "Start gratis proefperiode",
    register: "Registreren",
    email: "E-mail",
    password: "Wachtwoord",
    forgotPassword: "Wachtwoord vergeten?",
    alreadyHaveAccount: "Heb je al een account?",
    dontHaveAccount: "Heb je nog geen account?",
    errorDescription: "Er is een fout opgetreden",
    errorTitle: "Fout",
    successTitle: "Succes",
    successDescription: "Operatie succesvol uitgevoerd",
    continueWithGoogle: "Doorgaan met Google",
    createAccount: "Account aanmaken",
    trialDescription: "14 dagen gratis proberen",
    emailPlaceholder: "jouw@email.com",
    creating: "Aanmaken...",
    create: "Aanmaken",
    errorMessage: "Er is een fout opgetreden"
  },
  navigation: {
    pricing: "Prijzen",
    about: "Over ons",
    contact: "Contact",
    themes: "Thema's",
    resources: "Bronnen",
    home: "Home",
    dashboard: "Dashboard",
    products: "Producten",
    orders: "Bestellingen",
    customers: "Klanten",
    settings: "Instellingen"
  },
  footer: {
    acceptedPayments: "Geaccepteerde betalingen",
    allRightsReserved: "Alle rechten voorbehouden",
    quickLinks: "Snelle links",
    legalNotice: "Juridische kennisgeving",
    accessibility: "Toegankelijkheid",
    termsOfUse: "Gebruiksvoorwaarden",
    support: "Ondersteuning",
    followUs: "Volg ons",
    socialMedia: "Vind ons op sociale media",
    newsletter: "Nieuwsbrief",
    subscribeNewsletter: "Abonneer je op onze nieuwsbrief",
    emailPlaceholder: "Jouw e-mail",
    subscribe: "Abonneren",
    changeLanguage: "Taal wijzigen"
  },
  pricing: {
    title: "Plannen en prijzen",
    subtitle: "Kies het plan dat bij je past",
    startTrial: "Start gratis proefperiode",
    mostPopular: "Meest populair",
    freeTrial: "14 dagen gratis proberen",
    perMonth: "/maand",
    basic: {
      name: "Basis",
      price: "11",
      description: "Om te beginnen",
      features: [
        "1 winkel",
        "100 producten",
        "E-mail ondersteuning"
      ]
    },
    pro: {
      name: "Pro",
      price: "25",
      description: "Voor professionals",
      features: [
        "3 winkels",
        "1000 producten",
        "Prioriteit ondersteuning",
        "Geavanceerde analyses"
      ]
    },
    enterprise: {
      name: "Enterprise",
      price: "97",
      description: "Voor grote bedrijven",
      features: [
        "Onbeperkte winkels",
        "Onbeperkte producten",
        "Toegewijde ondersteuning",
        "Aangepaste API"
      ]
    }
  },
  profile: {
    title: "Mijn profiel",
    fullName: "Volledige naam",
    phoneNumber: "Telefoonnummer",
    update: "Bijwerken",
    updating: "Bijwerken...",
    success: "Profiel succesvol bijgewerkt",
    error: "Fout bij het bijwerken van profiel"
  },
  common: {
    loading: "Laden...",
    error: "Fout",
    success: "Succes",
    save: "Opslaan",
    cancel: "Annuleren",
    delete: "Verwijderen",
    edit: "Bewerken",
    create: "Aanmaken",
    search: "Zoeken",
    filter: "Filteren",
    sort: "Sorteren",
    actions: "Acties",
    confirm: "Bevestigen",
    back: "Terug",
    next: "Volgende",
    previous: "Vorige",
    close: "Sluiten"
  }
};
